module.exports = __webpack_public_path__ + "img/middle_01.d51fcfb.png";